import React from 'react';
import { getDisplayDate } from "../../../libs/date";
import GraphView from "../../GraphView";
import { observer } from 'mobx-react';
import { observable } from 'mobx';

@observer
class StationFullObservationGraph extends React.Component {

  insertMissingData = (observation, parameter_interval) => {
    let interval = parameter_interval * 60 * 1000;
    let data = [];
    let timeCounter = observation[0][0], endTime = observation[observation.length - 1][0];
    while (timeCounter <= endTime) {
      // eslint-disable-next-line
      let item = observation.find(item => Math.floor(item[0] / interval) * interval === Math.floor(timeCounter / interval) * interval);
      if (item) data.push(item);
      else data.push([timeCounter, null]);
      timeCounter += interval;
    }
    return data;
  }

  render() {
    const { stationObservation, parameters, pinGraph, onChangePinGraph } = this.props;

    let graphOptions = {
      chart: {
        zoomType: 'xy',
      },
      title: {
        style: {
          display: 'none'
        }
      },
      xAxis: [{
        type: 'datetime',
        dateTimeLabelFormats: { // don't display the dummy year
          second: '%H:%M:%S',
        },
      }],
      tooltip: {
        shared: true,
        followPointer: true,
      },
      legend: {
        enabled: true
      },
      plotOptions: {
        series: {
          animation: false
        },
      },
      yAxis: {
        title: {
          text: `values`
        },
      },
      series: []
    };

    stationObservation.forEach(station => {
      if (!!station.parameters) station.parameters.map(parameter => {
        let param = parameters.find(item => +item.id === +parameter.parameter_id);
        if (!!parameter.data) {
          const observation = parameter.data.map(({ time, value }) => [getDisplayDate(time, { returnMills: true }), Math.round(value * 100) / 100]);
          graphOptions.series.push({
            name: parameter.name,
            //data: parameter.data.filter(item => !!item.value || +item.value === 0).map(item => ([getDisplayDate(item.time, {returnMills: true}), Math.round(item.value * 100) / 100])),
            data: parameter.parameter_interval ? this.insertMissingData(observation, parameter.parameter_interval) : observation,
            visible: param && param.show,
            tooltip: {
              valueSuffix: ' ' + parameter.parameter_unit_symbol
            },
            type: parameter.parameter_property === "Accumulative" ? 'column' : 'line'
          })
        }
      });
    });

    return (
      <div style={pinGraph ? { position: 'sticky', top: 0, zIndex: 10000000000, background: 'white', borderBottom: '1px solid #bababa' } : {}}>
        <span className='fa fa-thumb-tack' style={{ position: 'relative', float: 'right', color: pinGraph ? '#3c8dbc' : 'gray', margin: 5 }} onClick={onChangePinGraph} />
        <GraphView options={graphOptions} />
      </div>
    );
  }
}

export default StationFullObservationGraph;


// WEBPACK FOOTER //
// ./src/components/Station/FullObservation/StationFullObservationGraph.js